/* Player vidéo frontend React — BEM gas-video-player-react. */

.gas-video-player-host {
    position: relative;
}

.gas-video-player-host__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--gas-space-l, 15px);
    background: color-mix(in srgb, var(--gas-color-surface-inverse, #000) 72%, transparent);
    z-index: 5;
}

.gas-video-player-host__panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--gas-space-m, 10px);
    max-width: 280px;
    padding: var(--gas-space-l, 15px);
    text-align: center;
    background: var(--gas-color-surface, #fff);
    border-radius: var(--gas-radius-l, 12px);
    color: var(--gas-color-text, #1a1a1a);
}


.gas-video-player-react {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-s, 7.5px);
    width: 100%;
}

.gas-video-player-react__title {
    margin: 0;
    font-size: var(--gas-text-l, 12.5px);
    font-weight: 600;
    color: var(--gas-color-text, #1a1a1a);
}

.gas-video-player-react__frame {
    position: relative;
    width: 100%;
    background: var(--gas-color-surface-inverse, #000);
    border-radius: var(--gas-radius-m, 8px);
    overflow: hidden;
}

.gas-video-player-react__media {
    display: block;
    width: 100%;
    height: auto;
    max-height: 80vh;
}

.gas-video-player-react--audio .gas-video-player-react__media {
    max-height: none;
}

.gas-video-player-react__error {
    margin: 0;
    padding: var(--gas-space-s, 7.5px);
    color: var(--gas-color-danger, #b3261e);
    background: var(--gas-color-danger-surface, #fce8e6);
    border-radius: var(--gas-radius-s, 4px);
    font-size: var(--gas-text-s, 8.75px);
}

.gas-video-player-react__quality {
    display: flex;
    align-items: center;
    gap: var(--gas-space-xs, 5px);
    font-size: var(--gas-text-s, 8.75px);
}

.gas-video-player-react__quality-label {
    color: var(--gas-color-text-muted, #5f6368);
}

.gas-video-player-react__quality-select {
    padding: var(--gas-space-xs, 3.75px) var(--gas-space-s, 5px);
    border: 1px solid var(--gas-color-border, #dadce0);
    border-radius: var(--gas-radius-s, 4px);
    background: var(--gas-color-surface, #fff);
    color: var(--gas-color-text, #1a1a1a);
    font-size: var(--gas-text-s, 8.75px);
}

.gas-video-player-react__meta {
    display: flex;
    gap: var(--gas-space-m, 10px);
    font-size: var(--gas-text-s, 8.75px);
    color: var(--gas-color-text-muted, #5f6368);
}

.gas-video-player-react__abloop {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--gas-space-xs, 3.75px);
    font-size: var(--gas-text-s, 8.75px);
}

.gas-video-player-react__abloop-label {
    color: var(--gas-color-text-muted, #5f6368);
    font-weight: 600;
}

/* Liste de chapitres rendue dans le corps d'un GasSection repliable :
   scroll interne borné pour ne pas allonger la page. */
.gas-video-player-react__chapter-list {
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow-y: auto;
    overscroll-behavior: contain;
    margin: calc(-1 * var(--gas-space-s, 7.5px)) calc(-1 * var(--gas-space-m, 10px));
}

.gas-video-player-react__chapter {
    display: flex;
    align-items: baseline;
    gap: var(--gas-space-s, 7.5px);
    padding: var(--gas-space-s, 6.25px) var(--gas-space-m, 10px);
    border: none;
    border-bottom: 1px solid var(--gas-color-border-subtle, #ececec);
    background: transparent;
    text-align: left;
    cursor: pointer;
    color: var(--gas-color-text, #1a1a1a);
    font-size: var(--gas-text-s, 8.75px);
}

.gas-video-player-react__chapter:hover {
    background: var(--gas-color-surface-alt, #f8f9fa);
}

.gas-video-player-react__chapter--active {
    background: var(--gas-color-primary-surface, #e8f0fe);
    font-weight: 600;
}

/* ─── Quiz overlay (cue points e-learning) ─── */

.gas-video-quiz-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--gas-space-l, 15px);
    background: color-mix(in srgb, var(--gas-color-surface-inverse, #000) 72%, transparent);
    z-index: 5;
}

.gas-video-quiz-overlay__panel {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-m, 10px);
    width: min(320px, 100%);
    padding: var(--gas-space-l, 15px);
    background: var(--gas-color-surface, #fff);
    border-radius: var(--gas-radius-l, 12px);
    color: var(--gas-color-text, #1a1a1a);
    max-height: 80vh;
    overflow-y: auto;
}

.gas-video-quiz-overlay__question {
    margin: 0;
    font-size: var(--gas-text-m, 10px);
    font-weight: 600;
    line-height: 1.4;
}

.gas-video-quiz-overlay__question-image {
    display: block;
    width: 100%;
    max-height: 34vh;
    margin-bottom: var(--gas-space-m);
    border-radius: var(--gas-radius-m);
    background: var(--gas-color-surface-subtle);
    object-fit: contain;
}

.gas-video-quiz-overlay__choices {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-xs, 3.75px);
}

.gas-video-quiz-overlay__choice {
    display: flex;
    align-items: center;
    gap: var(--gas-space-s, 7.5px);
    padding: var(--gas-space-s, 7.5px);
    border: 1px solid var(--gas-color-border, #d1d5db);
    border-radius: var(--gas-radius-m, 8px);
    cursor: pointer;
    transition: background 0.12s;
}

.gas-video-quiz-overlay__choice:hover {
    background: var(--gas-color-primary-surface, #e8f0fe);
}

.gas-video-quiz-overlay__choice--selected {
    border-color: var(--gas-color-primary, #2563eb);
    background: var(--gas-color-primary-surface, #e8f0fe);
    font-weight: 500;
}

.gas-video-quiz-overlay__radio {
    flex-shrink: 0;
    accent-color: var(--gas-color-primary, #2563eb);
}

.gas-video-quiz-overlay__bool-choices {
    display: flex;
    gap: var(--gas-space-m, 10px);
}

.gas-video-quiz-overlay__bool-choices .gas-video-quiz-overlay__choice {
    flex: 1;
    justify-content: center;
}

.gas-video-quiz-overlay__actions {
    display: flex;
    gap: var(--gas-space-s, 7.5px);
    justify-content: flex-end;
    flex-wrap: wrap;
}

.gas-video-quiz-overlay__result {
    margin: 0;
    font-size: var(--gas-text-m, 10px);
    font-weight: 700;
    text-align: center;
}

.gas-video-quiz-overlay__result--correct {
    color: var(--gas-color-success, #16a34a);
}

.gas-video-quiz-overlay__result--incorrect {
    color: var(--gas-color-danger, #dc2626);
}

.gas-video-quiz-overlay__explanation {
    margin: 0;
    font-size: var(--gas-text-s, 8.75px);
    color: var(--gas-color-text-muted, #6b7280);
    font-style: italic;
}

.gas-video-quiz-overlay__loading,
.gas-video-quiz-overlay__error,
.gas-video-quiz-overlay__manual-note {
    margin: 0;
    font-size: var(--gas-text-s, 8.75px);
    color: var(--gas-color-text-muted, #6b7280);
    text-align: center;
}

/* Drawer de transcription sous le player (single activité, e-learning). */
.gas-video-player-host__transcript {
    margin-top: var(--gas-space-m, 10px);
    max-height: 360px;
}
